import { shareReplay, startWith } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ColorService {
    private colors: string[] = [];

    public GetColors(minCount: number) {
        this.setRandomColors(minCount);
        return this.colors;
    }

    constructor() {}
    private setRandomColors(minCount: number) {
        if (this.colors.length < minCount) {
            const missingCount = minCount - this.colors.length;
            for (let i = 0; i < missingCount; i++) {
                const r = Math.floor(Math.random() * 255);
                const g = Math.floor(Math.random() * 255);
                const b = Math.floor(Math.random() * 255);
                this.colors.push(`rgba(${r}, ${g}, ${b}, 0.7)`);
            }
        }
    }
}
